export interface Bonus {
  title: string
  description: string
  /** Perceived (indicative) value supplied by the owner. Currency is set in data/offer.ts. */
  value: number
  /** Cover image of the bonus (1024 × 1024 px, book centred). */
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'La séance de secours',
    description: 'Des séances de secours sans instrument ni écran pour les remplacements et les imprévus.',
    value: 15,
    image:
      'https://cdn.magicpatterns.com/uploads/ad9Rxaov116JSDizXt4b2V/a403beb2-2b3c-46ba-9299-d1233b725e24-mockup.webp',
  },
  {
    title: 'Évaluer sans tout recommencer',
    description: 'Diagnostics, grilles et retours pour suivre les progrès sans reconstruire vos outils.',
    value: 17,
    image:
      'https://cdn.magicpatterns.com/uploads/uKh71xevg9qjkBmL48muTR/e4bea581-6c50-4025-aa43-f3e195cf4c64-mockup.webp',
  },
  {
    title: 'La musique pour chacun',
    description: 'Consignes visuelles, niveaux d’aide et options de participation pour des groupes hétérogènes.',
    value: 19,
    image:
      'https://cdn.magicpatterns.com/uploads/fdu8Qv8MxMppEMsgDzUNye/268cdc2d-d5f1-4a83-97f7-4834d021590a-mockup.webp',
  },
  {
    title: 'Notre rendez-vous musical',
    description: 'Rétroplanning, rôles, conducteurs et solutions de repli pour une restitution de classe.',
    value: 15,
    image:
      'https://cdn.magicpatterns.com/uploads/xva7EFUW2YTFwDMEyt6sGf/b45edf1e-5819-47f3-855e-ca702a005b0e-mockup.webp',
  },
  {
    title: 'Une classe de musique bien organisée',
    description: 'Rituels, cartes de rôles et outils pour préparer, distribuer, faire tourner les ateliers et ranger.',
    value: 20,
    image:
      'https://cdn.magicpatterns.com/uploads/fSKVG4hvZmKWBD4oj9CRHv/c90e3a42-794d-4bc4-9a11-cfdce6577cca-mockup.webp',
  },
]

export const bonusTotalValue = 86
